import React from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const InformationIconButton: React.FC<IconButtonProps> = (props) => {
  return (
    <IconButton {...props}><InfoOutlinedIcon /></IconButton>
  );
};